let cartCache = null;
let cartCacheTimestamp = 0;
const CACHE_DURATION = 2000; // 2 seconds

function getCartData() {
  const now = Date.now();
  
  // Return cached data if still valid
  if (cartCache && (now - cartCacheTimestamp) < CACHE_DURATION) {
    return Promise.resolve(cartCache);
  }
  
  return fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      cartCache = cart;
      cartCacheTimestamp = now;
      return cart;
    });
}

function addDiscountBadgesToOCC3() {
  getCartData()
    .then(cart => {
      if (!cart || !cart.items) return;
      
      const productCards = document.querySelectorAll('.spurit-occ3__product-card');
      
      productCards.forEach(card => {
        const key = card.getAttribute('data-occ3-cart-key');
        if (!key) return;
        
        const item = cart.items.find(i => i.key === key);
        if (!item || !item.discounts || item.discounts.length === 0) return;
        
        // Remove existing badges
        const existingBadge = card.querySelector('.cartly-discount-badge');
        if (existingBadge) {
          existingBadge.remove();
        }
        
        item.discounts.forEach(discount => {
          const badge = document.createElement('div');
          badge.className = 'cartly-discount-badge';
          badge.innerHTML = `
            <svg viewBox="0 0 20 20" class="Icon_Icon__uZZKy" style="width:20px;height:20px;">
              <path d="M12.78 8.28a.75.75 0 0 0-1.06-1.06l-4.5 4.5a.75.75 0 1 0 1.06 1.06l4.5-4.5Z"></path>
              <path d="M9 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"></path>
              <path d="M12 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"></path>
              <path fill-rule="evenodd" d="M12.094 3.514c-.822-1.79-3.366-1.79-4.188 0a.804.804 0 0 1-1.011.42c-1.848-.686-3.647 1.113-2.962 2.96a.804.804 0 0 1-.419 1.012c-1.79.822-1.79 3.366 0 4.188a.805.805 0 0 1 .42 1.011c-.686 1.848 1.113 3.647 2.96 2.962a.805.805 0 0 1 1.012.419c.822 1.79 3.366 1.79 4.188 0a.805.805 0 0 1 1.011-.42c1.848.686 3.647-1.113 2.962-2.96a.805.805 0 0 1 .419-1.012c1.79-.822 1.79-3.366 0-4.188a.805.805 0 0 1-.42-1.011c.686-1.848-1.113-3.647-2.96-2.962a.805.805 0 0 1-1.012-.419Zm-2.825.626a.804.804 0 0 1 1.462 0 2.304 2.304 0 0 0 2.896 1.2.804.804 0 0 1 1.034 1.034 2.304 2.304 0 0 0 1.199 2.895.804.804 0 0 1 0 1.462 2.304 2.304 0 0 0-1.2 2.896.805.805 0 0 1-1.034 1.034 2.304 2.304 0 0 0-2.895 1.199.804.804 0 0 1-1.462 0 2.304 2.304 0 0 0-2.896-1.2.804.804 0 0 1-1.033-1.034 2.305 2.305 0 0 0-1.2-2.895.804.804 0 0 1 0-1.462 2.304 2.304 0 0 0 1.2-2.896.804.804 0 0 1 1.033-1.033 2.304 2.304 0 0 0 2.896-1.2Z"></path>
            </svg>
            ${discount.title}
          `;
          
          const titleBlock = card.querySelector('.spurit-occ3__item-titles');
          if (titleBlock) titleBlock.appendChild(badge);
        });
      });
    })
    .catch(err => console.error('Cart fetch error:', err));
}

var occ3Observer = new MutationObserver(function(){
  var drawer = document.getElementById('occ3-drawer');
  if (!drawer) return;

  if (drawer.classList.contains('occ3-display-block')) {
    document.querySelectorAll('.spurit-occ3__item-titles').forEach(function(box){
      var variant = box.querySelector('.spurit-occ3__item-variant-title');
      if (variant && !variant.dataset.sizeFormatted) {
        variant.dataset.sizeFormatted = "1";
        variant.innerHTML =
          '<strong style="font-style:normal !important;line-height:1 !important;">Size:</strong> ' +
          variant.textContent.trim();

        variant.style.setProperty('font-style', 'normal', 'important');
        variant.style.setProperty('line-height', '1', 'important');
      }

      box.querySelectorAll('.occ3-properties').forEach(function(p){
        if (p.dataset.formatted) return;
        p.dataset.formatted = "1";

        var txt = p.textContent.trim();
        var parts = txt.split(':');
        if (parts.length < 2) return;

        var title = parts[0].trim();
        var value = parts[1].trim();

        var items = value
          .replace(/\s*\|\s*/g, ' ')
          .split(',')
          .map(function(v){
            v = v.trim();

            if (title.toLowerCase().includes('choose') && title.toLowerCase().includes('color')) {
              var m = v.match(/^(.*?)(\d+)\s+(\d+)$/);
              if (m) return m[1].trim() + ' ' + m[2] + ', QTY: ' + m[3];

              var m2 = v.match(/^(.*?)(\d+)$/);
              if (m2) return m2[1].trim() + ', QTY: ' + m2[2];
            }

            return v;
          })
          .filter(Boolean)
          .join('<br>');

        p.innerHTML =
          '<strong style="font-style:normal !important;line-height:1 !important;">' +
          title +
          ':</strong><br>' +
          items;

        p.style.setProperty('font-style', 'normal', 'important');
        p.style.setProperty('line-height', '1', 'important');
      });
    });
    addDiscountBadgesToOCC3();
  }
});

occ3Observer.observe(document.body, { attributes: true, subtree: true });

document.addEventListener('click', function(e){
  var btn = e.target.closest('.tpo_add-to-cart');
  if (!btn) return;

  e.preventDefault();
  e.stopImmediatePropagation();

  var form = btn.closest('form');
  if (!form) return;

  var data = new FormData(form);
  data.append('sections', 'cart-drawer');
  data.append('sections_url', window.location.pathname);

  fetch('/cart/add.js', { method: 'POST', body: data })
    .then(function(r){ return r.json(); })
    .then(function(){
      if (window.Spurit && Spurit.OneClickCheckout3 && Spurit.OneClickCheckout3.cartDrawer) {
        Spurit.OneClickCheckout3.cartDrawer.show();
        Spurit.OneClickCheckout3.cartDrawer.refresh();
      }
    });
});

